export default __webpack_public_path__ + "static/media/icon.ee73765c.svg";